export default {
	title: 'DTC区块链浏览器',
	allFilters:'全部筛选',
	addresses:'地址',
	contract:'合约',
	token:'代币',
	nameTags:'名称标记',
	domainNames:'域名',
	labels:'标签',
	websites:'网站',
	searchPlaceholder:'请输入地址 / 交易哈希 / 区块高度 / 代币',
	latestBlocks:'最新区块',
	latestTransactions:'最新交易',
	viewAllBlocks:'查看所有区块',
	viewAllTransactions:'查看所有交易',
	home:'首页',
	blockchain:'区块链',
	transactions:'交易',
	txn:'交易',
	pendingTransactions:'待处理交易',
	blocks:'区块',
	totalOf:'总共',
	dateTime:'日期时间 (UTC)',
	validator:'旷工',
	gasUsed:'燃料用量',
	gasLimit:'燃料限制',
	reward:'奖励',
	burntFees:'燃烧费用 (DTC)',
	overview:'概况',
	blockHeight:'区块高度',
	blockHeightSummary:'区块高度是指区块链中连接在一起的区块数量。当新区块的开采，区块高度就会增加。',
	timestamp:'时间戳',
	timestampSummary:'开采该区块的日期和时间。',
	transactionsSummary:'该区块中的交易数量。内部交易是由合约执行而产生和涉及以太价值的交易。',
	validatorSummary:'成功将区块纳入区块链的验证节点。',
	blockReward:'区块奖励',
	blockRewardSummary:'验证节点将会得到固定的奖励和区块中的交易费用（区块奖励会随着区块高度而调整）。',
	difficulty:'难度值',
	difficultySummary:'开采一个区块平均所需要的运算次数。 难度算法可能根据时间进行调整。',
	totalDifficulty:'总难度值',
	totalDifficultySummary:'区块高度的总难度。',
	size:'容量',
	sizeSummary:'区块容量取决于燃料限制。',
	gasUsedSummary:'该区块中使用的燃料和使用率百分比。',
	gasLimitSummary:'该区块中所有交易提供的总燃料限额。',
	extraData:'额外数据',
	extraDataSummary:'验证节点可以在区块中写入的任何数据。',
	hash:'哈希',
	hashSummary:'该区块的块头的哈希值。',
	parentHash:'父区块哈希值',
	parentHashSummary:'生成此区块的区块哈希，也称为父块。',
	sha3Uncles:'(Sha3) 叔区块',
	sha3UnclesSummary:'DTC Javascript RLP对空字符串进行编码的机制。',
	moreThan:'找到超过',
	transactionsFound:'个交易',
	transactionHash:'交易哈希',
	method:'方法',
	from:'发送方',
	to:'接收方',
	value:'价值',
	txnFee:'交易费用',
	transactionFee:'交易费用',
	internalTxns:'内部交易',
	log:'事件日志',
	state:'状况变化',
	transactionHashSummary:'交易哈希是一个唯一的66字符的标识符，该标识符在每次交易执行时都会生成。',
	status:'状态',
	statusSummary:'交易状态。',
	blocksSummary:'交易数据记录的区块高度。区块确认是此区块与最新区块之间的距离。',
	txnTimestampSummary:'交易数据记录的日期和时间。',
	transactionAction:'交易操作',
	transactionActionSummary:'交易的突出事件。',
	fromSummary:'交易的发送方（可能来自合约地址）。',
	toSummary:'交易的接收方（可以是合约地址）。',
	valueSummary:'该交易价值是以以太币和法定价值显示。注意：您可以单击法定价值（如果有），以查看交易时的历史价值。',
	transactionFeeSummary:'支付给验证节点用于处理交易的费用',
	gasPrice:'燃料价格',
	gasPriceSummary:'交易指定的每单位燃料成本，BNB和Gwei为支付单位。燃料费用越高，被写入区块的机会就越大。',
	inputData:'数据输入',
	inputDataSummary:'自定义数据，把您想要记录的数据写入该交易',
	copySuccessful:'复制成功',
	otherAttributes:'其他属性',
	otherAttributesSummary:'与此交易相关的其他数据',
	burntFeesSummary:'此tx燃烧的BNB总量。',
	usageByTxn:'Txn使用',
	usageByTxnSummary:'为交易分配的最大 gas 量以及最终使用的数量。正常的 BNB 转账涉及 21,000 gas 单位，而合约涉及更高的价值。',
	typeTraceAddress:'追溯地址类型',
	name:'名称',
	topics:'题目',
	data:'数据',
	viewMore:'查看更多',
	tokenTransfers:'代币转账 (DEP-20)',
	producedBlocks:'已开采区块',
	validatorSetInfo:'旷工信息设置',
	parentTransactionHash:'父区块交易哈希值',
	tokenTransferEvents:'代币转移事件',
	feeAddress:'费用地址',
	BCFeeAddress:'BC费用地址',
	votingPower:'投票权',
	incoming:'接收',
	systemAbnormality:'系统异常',
	in3secs:'3 秒前',
	feeRecipient:'验证节点',
	success:'成功',
	fail:'失败',
	times:'笔',
	tokenAmountRanking:'代币金额排行榜',
	tokenTradingList:'代币交易列表',
	amount:'金额',
	contractAddressSummary:'合约地址是在区块链网络中用于表示智能合约的唯一标识',
	type:'类型',
	holders:'持有人',
	totalSupply:'总供应量',
	noData:'暂无数据',
	otherInfo:'其他信息',
	percentage:'百分率',
	transfers:'转移',
	Info:'信息',
	quantity:'数量',
	tokensTransferred:'已转移的代币',
	tokensTransferredSummary:'交易中转移的 ERC-20 代币列表',
	balance:'余额',
}